import { useSelector } from 'react-redux'
import { getAccounts } from '../reducers/accounts';
/**
 * Get the accounts
 */
export default function useAccounts() {
    const accounts = useSelector(getAccounts);
    return accounts || [];
};
